import React from "react";

import styled from "styled-components";
import {
  space,
  SpaceProps,
  layout,
  LayoutProps,
  display,
  DisplayProps,
} from "styled-system";

interface StyledProps extends SpaceProps, LayoutProps, DisplayProps {
  children?: React.ReactNode;
}

const StyledContainer = styled.div<StyledProps>`
  display: flex;
  ${display}
  ${space}
  ${layout}
`;

const VatTypeSVG: React.FunctionComponent<StyledProps> = (props) => {
  return (
    <StyledContainer {...props} data-testid="vat-type-container">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="14"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        data-testid="vat-type-svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.96875 0V4.78125C7.96875 5.27344 8.32031 5.625 8.8125 5.625H13.5938V17.1562C13.5938 17.6484 13.207 18 12.75 18H0.9375C0.445312 18 0.09375 17.6484 0.09375 17.1562V0.84375C0.09375 0.386719 0.445312 0 0.9375 0H7.96875ZM13.3477 3.69141C13.4883 3.86719 13.5938 4.07812 13.5938 4.28906V4.5H9.09375V0H9.30469C9.51562 0 9.72656 0.105469 9.90234 0.246094L13.3477 3.69141ZM4.30778 8L3.52278 10.7301L2.74049 8H1.6875L3.00306 11.75H4.04251L5.36889 8H4.30778ZM7.69102 11.0495H6.389L6.16162 11.75H5.14653L6.59202 8H7.48529L8.94161 11.75H7.92111L7.69102 11.0495ZM7.46364 10.3515H6.61638L7.03865 9.05083L7.46364 10.3515ZM10.8171 8.69798H12V8H8.70571V8.69798H9.86697V11.75H10.8171V8.69798Z"
          fill="#2196F3"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.96875 0V4.78125C7.96875 5.27344 8.32031 5.625 8.8125 5.625H13.5938V17.1562C13.5938 17.6484 13.207 18 12.75 18H0.9375C0.445312 18 0.09375 17.6484 0.09375 17.1562V0.84375C0.09375 0.386719 0.445312 0 0.9375 0H7.96875ZM13.3477 3.69141C13.4883 3.86719 13.5938 4.07812 13.5938 4.28906V4.5H9.09375V0H9.30469C9.51562 0 9.72656 0.105469 9.90234 0.246094L13.3477 3.69141ZM4.30778 8L3.52278 10.7301L2.74049 8H1.6875L3.00306 11.75H4.04251L5.36889 8H4.30778ZM7.69102 11.0495H6.389L6.16162 11.75H5.14653L6.59202 8H7.48529L8.94161 11.75H7.92111L7.69102 11.0495ZM7.46364 10.3515H6.61638L7.03865 9.05083L7.46364 10.3515ZM10.8171 8.69798H12V8H8.70571V8.69798H9.86697V11.75H10.8171V8.69798Z"
          fill="#404040"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.96875 0V4.78125C7.96875 5.27344 8.32031 5.625 8.8125 5.625H13.5938V17.1562C13.5938 17.6484 13.207 18 12.75 18H0.9375C0.445312 18 0.09375 17.6484 0.09375 17.1562V0.84375C0.09375 0.386719 0.445312 0 0.9375 0H7.96875ZM13.3477 3.69141C13.4883 3.86719 13.5938 4.07812 13.5938 4.28906V4.5H9.09375V0H9.30469C9.51562 0 9.72656 0.105469 9.90234 0.246094L13.3477 3.69141ZM4.30778 8L3.52278 10.7301L2.74049 8H1.6875L3.00306 11.75H4.04251L5.36889 8H4.30778ZM7.69102 11.0495H6.389L6.16162 11.75H5.14653L6.59202 8H7.48529L8.94161 11.75H7.92111L7.69102 11.0495ZM7.46364 10.3515H6.61638L7.03865 9.05083L7.46364 10.3515ZM10.8171 8.69798H12V8H8.70571V8.69798H9.86697V11.75H10.8171V8.69798Z"
          fill="#070B16"
        />
      </svg>
    </StyledContainer>
  );
};

export default VatTypeSVG;
